import React, { useRef, useCallback } from "react";
import clsx from "clsx";

const ReactionButton = ({ 
    reaction, 
    count, 
    isUserReacted, 
    onClick, 
    onLongPress,
    className = "" 
}) => {
    const timeoutRef = useRef(null);
    const isLongPress = useRef(false);

    const handleMouseDown = useCallback(() => {
        isLongPress.current = false;
        timeoutRef.current = setTimeout(() => {
            isLongPress.current = true;
            onLongPress?.();
        }, 500); // 500ms for long press
    }, [onLongPress]);

    const handleMouseUp = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);

    const handleMouseLeave = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);

    const handleClick = useCallback((e) => {
        if (isLongPress.current) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        onClick?.(e);
    }, [onClick]);

    return (
        <button
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
            onTouchStart={handleMouseDown}
            onTouchEnd={handleMouseUp}
            onClick={handleClick}
            className={clsx(
                "tw-flex tw-items-center tw-gap-1 tw-px-2 tw-h-[2em] tw-rounded-full tw-transition-all tw-duration-200 tw-text-sm tw-font-medium",
                {
                    "tw-bg-purple-100 tw-text-purple-700": isUserReacted,
                    "tw-bg-gray-100 tw-text-gray-700 hover:tw-bg-gray-200": !isUserReacted,
                },
                className
            )}
        >
            <span className="tw-text-sm">{reaction}</span>
            {count > 0 && (
                <span className="tw-font-semibold">{count}</span>
            )}
        </button>
    );
};

export default ReactionButton; 